var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group/Icon/Bed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.5992 19.65V13.05C29.5992 12.5726 29.4096 12.1148 29.072 11.7772C28.7344 11.4396 28.2766 11.25 27.7992 11.25H12.1992C11.7218 11.25 11.264 11.4396 10.9264 11.7772C10.5889 12.1148 10.3992 12.5726 10.3992 13.05V19.65M9.19922 26.85V29.25M30.7992 26.85V29.25",
    stroke: "#FB8400",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "#ffffff",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6 16.6499H14C13.5226 16.6499 13.0648 16.8395 12.7272 17.1771C12.3896 17.5147 12.2 17.9725 12.2 18.4499V19.6499H19.4V18.4499C19.4 17.9725 19.2104 17.5147 18.8728 17.1771C18.5352 16.8395 18.0774 16.6499 17.6 16.6499ZM26 16.6499H22.4C21.9226 16.6499 21.4648 16.8395 21.1272 17.1771C20.7896 17.5147 20.6 17.9725 20.6 18.4499V19.6499H27.8V18.4499C27.8 17.9725 27.6104 17.5147 27.2728 17.1771C26.9352 16.8395 26.4774 16.6499 26 16.6499ZM8 21.4499C8 20.9725 8.18964 20.5147 8.52721 20.1771C8.86477 19.8395 9.32261 19.6499 9.8 19.6499H30.2C30.6774 19.6499 31.1352 19.8395 31.4728 20.1771C31.8104 20.5147 32 20.9725 32 21.4499V26.8499H8V21.4499Z",
    stroke: "#FB8400",
    fill: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bed.4623a74f.svg";
export { ForwardRef as ReactComponent };